import type { FaireProductEntity } from "../../entity_types/product";

export const p_9hu8nc34k4: FaireProductEntity = {
  token: "p_9hu8nc34k4",
  type: "product",
  name: "Plant-Based Protein",
  brandToken: "b_42evg3vp59",
  brandName: "Clean Monday Meals",
  imageUrl:
    "https://cdn.faire.com/fastly/a9fadeee004e006650067af9b395fe25a9af48cc64bce456de2725286eba6f94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/282769319305171ca0a38e04d551f0b14ab4d3944486dfaede32f46893f5d110.png",
    "https://cdn.faire.com/fastly/73070b3668fc8ac690083e3b5731983508833c3726ebf183568179f18e84d158.jpeg",
    "https://cdn.faire.com/fastly/36012e1e977c0f05dd02014cecd2a42fe85fc5305e5ac3b6ee2cab0dc68aae8c.jpeg",
    "https://cdn.faire.com/fastly/4e1d1ab8a66a48f0aacbc0fe863fb1787f8d222fb0e7b8befc4e84199867802c.jpeg",
    "https://cdn.faire.com/fastly/ffe7d0981f6b865b86bed1ae51be582cf77418cfc1dc89e8dd45cd46f49729b3.jpeg",
    "https://cdn.faire.com/fastly/e668a89fab85fdcdbf7e4b06618d2845f3bb5d736018b7b27e5abdc834c89121.jpeg",
    "https://cdn.faire.com/fastly/587c60722dd1f01651bfa4d69c3443d0573b0865ce0cfeefef139646bf4dd0da.jpeg",
    "https://cdn.faire.com/fastly/733fa8282b0d87c96f0ca59e2ae726cb498ce871db0eeb1ee419b2f863dd996d.jpeg",
    "https://cdn.faire.com/fastly/3d3375a9916f3f57a7fdacf91c6661990faff6cd3f2cb289c4c747cd0a9f73f7.jpeg",
    "https://cdn.faire.com/fastly/2d72f6a991972636ed80226f53f58cad6259c6fdefb9d8db327c073cb531dc34.jpeg",
    "https://cdn.faire.com/fastly/399f58efef8c227034bd99876f61c034b305ec224320a263de6ed5f57e1f7d89.jpeg",
    "https://cdn.faire.com/fastly/488dbb06bd3519635ea0c5e8c925c0998f9035f652bc2bd6da1a5cebd07cb532.png",
    "https://cdn.faire.com/fastly/c5f436e73fcfac84f579a76c2a76447a4e211bacef6b5425028dc48a22d02f98.png",
  ],
  priceDollars: 1.79,
  description:
    "The Smoothest, best-tasting plant-based protein we've ever had. \nZero grit. No bloating. Just clean, craveable flavor you’ll actually look forward to.\n\nWe weren’t even planning on launching a protein powder—at least not yet. But during a meeting with a potential manufacturer, we shared our dream list of future Clean Monday Meals products. Somewhere near the bottom was plant-based protein. As soon as the words came out, our guy Troy—who we now call Willy Wonka (thanks to his obsession with flavor)—lit up. He told us he had been working on the perfect plant protein blend for over a decade and asked if we’d be willing to try it.\n\nOne taste and we knew — this was the one.\nThis was the clean, vegan protein powder we’d been searching for. It’s made with North American pea protein, but what makes it different is the proprietary process used to create it. It dissolves completely, without the grit or sludge you get from most plant proteins. ",
  tags: [],
  msrpDollars: 2.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:20.150Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
